export const SUN_LIFE_PROPOSAL_INFO_FORM_ID = 'sun-life-proposal-info-form';
export const SUN_LIFE_SIC_WARNING_ALERT_TEST_ID = 'sun-life-proposal-info-sic-warning-alert';
